"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageableLicensesConverter = void 0;
const LicensesConverter_1 = require("./LicensesConverter");
class PageableLicensesConverter {
    static convert(entity) {
        return {
            page: entity._embedded.map((license) => LicensesConverter_1.LicensesConverter.convert(license)),
            pageSpec: {
                totalPages: entity.page.totalPages,
                number: entity.page.number,
                size: entity.page.size,
                totalElements: entity.page.totalElements,
            },
        };
    }
}
exports.PageableLicensesConverter = PageableLicensesConverter;
//# sourceMappingURL=PageableLicensesConverter.js.map